import React from 'react'
import { Icon } from '@chakra-ui/icons'
import { Button } from '@chakra-ui/react'
import { Box, Text } from '@chakra-ui/react'
import { FaMagnifyingGlass } from 'react-icons/fa6'

import SharedStack from '~components/shared/wrappers/shared-stack'
import { getOS } from '~utils/os-helpers'

interface SiteSearchBarProps {
    onClick: () => void
}

export default function SiteSearchBar({ onClick }: SiteSearchBarProps) {
    const os = getOS()

    return (
        <Button
            variant="subtle"
            size="md"
            fontSize="sm"
            rounded="xl"
            w="full"
            maxW="540px"
            justifyContent="space-between"
            fontWeight="normal"
            color="gray.500"
            textAlign="left"
            px={3}
            onClick={onClick}
        >
            <SharedStack row spacing={2}>
                <Icon as={FaMagnifyingGlass} fontSize="xs" color="gray.500" />
                <Text fontSize="xs">
                    Search settings, pages, clients, patients, etc...
                </Text>
            </SharedStack>
            <Box
                as="span"
                bg="white"
                fontSize="10px"
                fontWeight="semibold"
                color="gray.900"
                rounded="md"
                px={1.5}
                py={1}
                borderWidth={1}
                ml={4}
            >
                {os === 'Mac OS' ? 'Cmd+K' : 'Ctrl+K'}
            </Box>
        </Button>
    )
}
